import script from "./manage.vue?vue&type=script&setup=true&lang=js"
export * from "./manage.vue?vue&type=script&setup=true&lang=js"

import "./manage.vue?vue&type=style&index=0&id=212dd395&lang=stylus&scoped=true"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212dd395"]])

export default __exports__